import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy, Suspense, ReactNode } from 'react';
import { Login } from './pages/Login';
import { LayoutShell } from './components/LayoutShell';
import { Spinner } from './components/Spinner';

const Projects        = lazy(() => import('./pages/Projects'));
const Board           = lazy(() => import('./pages/Board'));
const UsersAdmin      = lazy(() => import('./pages/UsersAdmin'));
const Health          = lazy(() => import('./pages/Health'));
const ProjectSettings = lazy(() => import('./pages/ProjectSettings'));

function Lazy({ children }: { children: ReactNode }) {
  return (
    <Suspense fallback={<div className="flex h-full items-center justify-center"><Spinner size={24} /></div>}>
      {children}
    </Suspense>
  );
}

export const router = createBrowserRouter([
  { path: '/login', element: <Login /> },
  {
    element: <LayoutShell />,
    children: [
      { path: '/',                     element: <Lazy><Projects /></Lazy> },
      { path: '/board/:slug',          element: <Lazy><Board /></Lazy> },
      { path: '/board/:slug/settings', element: <Lazy><ProjectSettings /></Lazy> },
      { path: '/admin/users',          element: <Lazy><UsersAdmin /></Lazy> },
      { path: '/admin/health',         element: <Lazy><Health /></Lazy> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
